import { useLocation, Route, Routes } from 'react-router-dom'

import { useSettings } from '@loadsmart/react-frontend-settings'

import FIAIRedirect from 'auth/ui/FIAIRedirect'
import LoginPage from 'auth/ui/LoginPage'
import LoginThroughBIP from 'auth/ui/LoginThroughBIP'
import LoginThroughBIPCallback from 'auth/ui/LoginThroughBIPCallback'
import OpenDockLoginPage from 'auth/ui/OpenDockLoginPage'
import LogoutPage from 'auth/ui/LogoutPage'
import HomePage from 'home/ui/HomePage'
import AnalyticsLibraryPage from 'managed-analytics/ui/AnalyticsLibraryPage'
import AnalyticsMcpPage from 'managed-analytics/ui/AnalyticsMcpPage'
import DemoReportPage from 'managed-analytics/ui/DemoReportPage'
import IntegrationsPage from 'managed-analytics/ui/IntegrationsPage'
import ManagedAnalyticsPage from 'managed-analytics/ui/ManagedAnalyticsPage'
import PerformanceReportsPage from 'managed-analytics/ui/PerformanceReportsPage'
import ReportPage from 'managed-analytics/ui/ReportPage'
import SchedulePage from 'managed-analytics/ui/SchedulePage'

import MobileNotSupported from './components/mobile/MobileNotSupported'
import PrivatePage from './components/PrivatePage'

const Router = () => {
  const location = useLocation()
  const {
    isLoading,
    values,
  } = useSettings(['flags.ENABLE_LOGIN_THROUGH_BIP', 'flags.ENABLE_LOGIN_THROUGH_OPENDOCK'])

  const [isLoginThroughBIPEnabled, isOpenDockLoginEnabled] = values

  console.log('[Router] Raw feature flags received:', {
    isLoading,
    rawValues: values,
    rawValuesType: typeof values,
    rawBIPFlag: isLoginThroughBIPEnabled,
    rawBIPFlagType: typeof isLoginThroughBIPEnabled,
    rawOpenDockFlag: isOpenDockLoginEnabled,
    rawOpenDockFlagType: typeof isOpenDockLoginEnabled,
  })

  const isBIPEnabled = Boolean(isLoginThroughBIPEnabled)
  const isOpenDockEnabled = Boolean(isOpenDockLoginEnabled)

  return isLoading ? null : (
    <Routes>
      <Route path="/" element={<HomePage />} />
      {isBIPEnabled ? (
        <>
          <Route path="/login" element={<LoginThroughBIP />} />
          <Route path="/login-callback" element={<LoginThroughBIPCallback />} />
        </>
      ) : (
        <Route path="/login" element={<LoginPage />} />
      )}
      <Route path="/login-lmt" element={<LoginPage />} />
      {isOpenDockEnabled && (
        <Route path="/login-opendock" element={<OpenDockLoginPage />} />
      )}
      <Route path="/logout" element={<LogoutPage />} />

      <Route element={<PrivatePage />}>
        <Route path="/analytics" element={<ManagedAnalyticsPage key={location.key} />} />
        <Route path="/integrations" element={<IntegrationsPage />} />
        <Route path="/schedule" element={<SchedulePage />} />
        <Route path="/performance-reports" element={<PerformanceReportsPage />} />
        <Route path="/reports/:reportId" element={<ReportPage />} />
      </Route>
      <Route path="/demo" element={<AnalyticsLibraryPage />} />
      <Route path="/demo-reports/:reportId" element={<DemoReportPage />} />
      <Route path="/analytics-mcp" element={<AnalyticsMcpPage />} />

      <Route path="/mobile-not-supported" element={<MobileNotSupported />} />
      <Route path="/fiai_redirect" element={<FIAIRedirect />} />
    </Routes>
  )
}

export default Router
